import { getRequest, postRequest } from "../../../api/api";

export function getTransactionSummary(callbackResponse) {
    return getRequest(
        'api/v1/wallet/net-fund',
        null,
        callbackResponse
    );
};

export function getTransactionData(page, params, callbackResponse) {
    return getRequest(
        'api/v1/wallet/transactions?page=' + page,
        params,
        callbackResponse
    );
};

export function getCashflowTypeFilter(callbackResponse) {
    return getRequest(
        'api/v1/wallet/cashflow-type-list',
        null,
        callbackResponse
    );
};

export function postCancelWithdrawal(values, callbackResponse, callbackError) {
    return postRequest(
        'api/v1/wallet/cancel-withdraw',
        null,
        values,
        callbackResponse,
        callbackError
    );
};